import styled from 'styled-components'
import media from 'styled-media-query'

const GroupLinksDiv = styled.div`
  display: flex;
  justify-content: ${({ isBr }) => isBr ? "space-between" : "start"};
  gap: ${({ isBr }) => isBr ? "0px" : "160px"};

  ${media.lessThan('medium')`
    display: none;
  `}
`

const FooterTitle = styled.div`
  color: #d12673;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 1.6rem;

  &.contact-footer {
    ${media.lessThan('medium')`
      margin-bottom: 3.2rem;
    `}
  }
`
export const FooterLittleTitle = styled.div`
  color: #d12673;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0;
`
export const SubLittleTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #000e40;
  margin-bottom: 1.2rem;
`

export const Title = styled.p`
  margin: 0;
`

export { GroupLinksDiv, FooterTitle }
